// @generated by protoc-gen-es v2.14.1 with parameter "target=ts"
// @generated from file catalogos_monitoreo.proto (package sextante.catalogos.monitoreo.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file catalogos_monitoreo.proto.
 */
export const file_catalogos_monitoreo: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * Plaga o enfermedad del catalogo, con sus umbrales y la forma de registrarla en campo.
 *
 * @generated from message sextante.catalogos.monitoreo.v1.MonitoreoPlagaEnfermedadItem
 */
export type MonitoreoPlagaEnfermedadItem = Message<"sextante.catalogos.monitoreo.v1.MonitoreoPlagaEnfermedadItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * true si el registro se dio de baja en el catalogo: la app lo quita de su copia local.
   *
   * @generated from field: bool eliminado = 2;
   */
  eliminado: boolean;

  /**
   * @generated from field: bool is_monitoreo_citricos = 6;
   */
  isMonitoreoCitricos: boolean;

  /**
   * @generated from field: bool is_monitoreo_aguacate_hass = 7;
   */
  isMonitoreoAguacateHass: boolean;

  /**
   * @generated from field: bool is_monitoreo_mango = 8;
   */
  isMonitoreoMango: boolean;

  /**
   * @generated from field: bool is_monitoreo_macadamia = 9;
   */
  isMonitoreoMacadamia: boolean;

  /**
   * @generated from field: bool is_monitoreo_guanabana = 10;
   */
  isMonitoreoGuanabana: boolean;

  /**
   * @generated from field: bool is_monitoreo_papa = 11;
   */
  isMonitoreoPapa: boolean;

  /**
   * @generated from field: string grupo = 12;
   */
  grupo: string;

  /**
   * Orden para mostrar la plaga.
   *
   * @generated from field: int32 orden = 13;
   */
  orden: number;

  /**
   * @generated from field: string nombre_comun = 14;
   */
  nombreComun: string;

  /**
   * @generated from field: string nombre_tecnico = 15;
   */
  nombreTecnico: string;

  /**
   * Umbral de precaucion de la incidencia. 0 = sin umbral.
   *
   * @generated from field: int32 rango_bajo = 17;
   */
  rangoBajo: number;

  /**
   * Umbral de alerta de la incidencia. 0 = sin umbral.
   *
   * @generated from field: int32 rango_medio = 18;
   */
  rangoMedio: number;

  /**
   * Plaga critica: cualquier deteccion es alerta, sin usar los umbrales.
   *
   * @generated from field: bool is_critico = 19;
   */
  isCritico: boolean;

  /**
   * Texto libre del catalogo sobre la logica del umbral. Hoy la app no lo consulta.
   *
   * @generated from field: string logica_umbral = 20;
   */
  logicaUmbral: string;

  /**
   * Abreviatura de la plaga.
   *
   * @generated from field: optional string abrev = 21;
   */
  abrev?: string | undefined;

  /**
   * Campos de captura: cómo registra el monitor esta plaga.
   * tipo_medicion: conteo | conteoAlto | porcentaje | escala | binario.
   * denominador_muestra: sobre cuántas unidades se promedia (ej. 10 plantas). Ausente = no aplica.
   * unidad: texto a mostrar junto al valor (ej. "larvas/planta"). Ausente = no aplica.
   * pasos_escala: valores seleccionables para porcentaje/escala (ej. [0,1,1.5,3,5,10]). Vacío = no aplica.
   *
   * @generated from field: string tipo_medicion = 22;
   */
  tipoMedicion: string;

  /**
   * @generated from field: optional int32 denominador_muestra = 23;
   */
  denominadorMuestra?: number | undefined;

  /**
   * @generated from field: optional string unidad = 24;
   */
  unidad?: string | undefined;

  /**
   * @generated from field: repeated double pasos_escala = 25;
   */
  pasosEscala: number[];

  /**
   * --- Identidad del organismo (especificacion v1.0, 6.2) ---
   * organismo_id NO es el id de esta fila ni el plaga_id legacy: identifica al ORGANISMO,
   * que puede aparecer en varios cultivos. Es lo que permite que una finca con limon y
   * naranja muestre "Acaro blanco" una sola vez en vez de dos.
   *
   * @generated from field: optional string organismo_id = 26;
   */
  organismoId?: string | undefined;

  /**
   * @generated from field: optional string nombre_cientifico = 27;
   */
  nombreCientifico?: string | undefined;

  /**
   * Grupo normalizado (ACARO, INSECTO, HONGO, BACTERIA, OOMICETO, BENEFICO). Distinto de
   * `grupo`, que es texto libre del catalogo viejo. BENEFICO nunca alerta.
   *
   * @generated from field: optional string grupo_id = 28;
   */
  grupoId?: string | undefined;
};

/**
 * Describes the message sextante.catalogos.monitoreo.v1.MonitoreoPlagaEnfermedadItem.
 * Use `create(MonitoreoPlagaEnfermedadItemSchema)` to create a new message.
 */
export const MonitoreoPlagaEnfermedadItemSchema: GenMessage<MonitoreoPlagaEnfermedadItem> = /*@__PURE__*/
  messageDesc(file_catalogos_monitoreo, 0);

/**
 * Que organismo se monitorea en que cultivo, y con que valores de referencia por defecto.
 * 
 * Es la tabla B de la especificacion: lo que permite que limon, naranja y mandarina tengan
 * umbrales propios. En el catalogo viejo los tres comparten la fila "Citricos" y por lo tanto
 * el mismo umbral, que es justo lo que esto viene a resolver.
 * 
 * Los cuatro umbrales van `optional` porque ausente significa "sin referencia" -el organismo
 * se monitorea y se muestra, pero no alerta-, no "umbral cero".
 *
 * @generated from message sextante.catalogos.monitoreo.v1.MonitoreoCultivoPlagaItem
 */
export type MonitoreoCultivoPlagaItem = Message<"sextante.catalogos.monitoreo.v1.MonitoreoCultivoPlagaItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: bool eliminado = 2;
   */
  eliminado: boolean;

  /**
   * Hora de la ultima modificacion en Unix ms, para el delta del cliente.
   *
   * @generated from field: int64 ultima_actualizacion = 3;
   */
  ultimaActualizacion: bigint;

  /**
   * Cultivo especifico: limon, naranja, mandarina, Hass... No el tipo de monitoreo.
   *
   * @generated from field: string cultivo_id = 4;
   */
  cultivoId: string;

  /**
   * Fila del catalogo de plagas. Varias filas de esta tabla pueden apuntar a la misma.
   *
   * @generated from field: string plaga_enfermedad_id = 5;
   */
  plagaEnfermedadId: string;

  /**
   * Orden de presentacion dentro del cultivo.
   *
   * @generated from field: int32 orden = 6;
   */
  orden: number;

  /**
   * Como se llama el organismo en este cultivo. Puede diferir del nombre del catalogo.
   *
   * @generated from field: string etiqueta = 7;
   */
  etiqueta: string;

  /**
   * Como se mide: ACAROS_LUPADA | INDIVIDUOS_ARBOL | PORCENTAJE_ARBOLES | PRESENCIA_CRITICA.
   *
   * @generated from field: string unidad = 8;
   */
  unidad: string;

  /**
   * @generated from field: optional double nivel_bajo_max = 9;
   */
  nivelBajoMax?: number | undefined;

  /**
   * @generated from field: optional double nivel_medio_max = 10;
   */
  nivelMedioMax?: number | undefined;

  /**
   * % de arboles
   *
   * @generated from field: optional double incidencia_bajo_max = 11;
   */
  incidenciaBajoMax?: number | undefined;

  /**
   * % de arboles
   *
   * @generated from field: optional double incidencia_medio_max = 12;
   */
  incidenciaMedioMax?: number | undefined;
};

/**
 * Describes the message sextante.catalogos.monitoreo.v1.MonitoreoCultivoPlagaItem.
 * Use `create(MonitoreoCultivoPlagaItemSchema)` to create a new message.
 */
export const MonitoreoCultivoPlagaItemSchema: GenMessage<MonitoreoCultivoPlagaItem> = /*@__PURE__*/
  messageDesc(file_catalogos_monitoreo, 1);

/**
 * Un tamano de fruta: F1 canica, F2 pimpon, F3 grande. Solo frutales.
 * 
 * OJO con el codigo: F1/F2/F3 tambien son las generaciones filiales de la papa, que viven en el
 * catalogo de estados fenologicos. Son dos cosas distintas con las mismas etiquetas, y lo que las
 * distingue es de que catalogo salen, no el texto.
 *
 * @generated from message sextante.catalogos.monitoreo.v1.MonitoreoTamanoFrutaItem
 */
export type MonitoreoTamanoFrutaItem = Message<"sextante.catalogos.monitoreo.v1.MonitoreoTamanoFrutaItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: bool eliminado = 2;
   */
  eliminado: boolean;

  /**
   * @generated from field: int32 orden = 3;
   */
  orden: number;

  /**
   * El boton: "F1", "F2", "F3".
   *
   * @generated from field: string codigo = 4;
   */
  codigo: string;

  /**
   * En palabras: "Canica", "Pimpon", "Grande". Es lo que hace legible el informe, donde un "F1"
   * suelto no le dice nada a quien no monitorea.
   *
   * @generated from field: string descripcion = 5;
   */
  descripcion: string;
};

/**
 * Describes the message sextante.catalogos.monitoreo.v1.MonitoreoTamanoFrutaItem.
 * Use `create(MonitoreoTamanoFrutaItemSchema)` to create a new message.
 */
export const MonitoreoTamanoFrutaItemSchema: GenMessage<MonitoreoTamanoFrutaItem> = /*@__PURE__*/
  messageDesc(file_catalogos_monitoreo, 2);

/**
 * Pedido del catalogo de tamanos.
 *
 * @generated from message sextante.catalogos.monitoreo.v1.ListMonitoreoTamanosFrutaRequest
 */
export type ListMonitoreoTamanosFrutaRequest = Message<"sextante.catalogos.monitoreo.v1.ListMonitoreoTamanosFrutaRequest"> & {
  /**
   * @generated from field: int64 ultima_sincronizacion = 1;
   */
  ultimaSincronizacion: bigint;
};

/**
 * Describes the message sextante.catalogos.monitoreo.v1.ListMonitoreoTamanosFrutaRequest.
 * Use `create(ListMonitoreoTamanosFrutaRequestSchema)` to create a new message.
 */
export const ListMonitoreoTamanosFrutaRequestSchema: GenMessage<ListMonitoreoTamanosFrutaRequest> = /*@__PURE__*/
  messageDesc(file_catalogos_monitoreo, 3);

/**
 * Tamanos que cambiaron desde la ultima sincronizacion.
 *
 * @generated from message sextante.catalogos.monitoreo.v1.ListMonitoreoTamanosFrutaResponse
 */
export type ListMonitoreoTamanosFrutaResponse = Message<"sextante.catalogos.monitoreo.v1.ListMonitoreoTamanosFrutaResponse"> & {
  /**
   * @generated from field: repeated sextante.catalogos.monitoreo.v1.MonitoreoTamanoFrutaItem items = 1;
   */
  items: MonitoreoTamanoFrutaItem[];

  /**
   * @generated from field: int64 timestamp_sincronizacion = 2;
   */
  timestampSincronizacion: bigint;
};

/**
 * Describes the message sextante.catalogos.monitoreo.v1.ListMonitoreoTamanosFrutaResponse.
 * Use `create(ListMonitoreoTamanosFrutaResponseSchema)` to create a new message.
 */
export const ListMonitoreoTamanosFrutaResponseSchema: GenMessage<ListMonitoreoTamanosFrutaResponse> = /*@__PURE__*/
  messageDesc(file_catalogos_monitoreo, 4);

/**
 * Pedido de la tabla por cultivo.
 *
 * @generated from message sextante.catalogos.monitoreo.v1.ListMonitoreoCultivoPlagasRequest
 */
export type ListMonitoreoCultivoPlagasRequest = Message<"sextante.catalogos.monitoreo.v1.ListMonitoreoCultivoPlagasRequest"> & {
  /**
   * Delta: ultima sincronizacion en Unix ms, el timestamp_sincronizacion de la respuesta
   * anterior. Con 0 trae todo.
   *
   * @generated from field: int64 ultima_sincronizacion = 1;
   */
  ultimaSincronizacion: bigint;
};

/**
 * Describes the message sextante.catalogos.monitoreo.v1.ListMonitoreoCultivoPlagasRequest.
 * Use `create(ListMonitoreoCultivoPlagasRequestSchema)` to create a new message.
 */
export const ListMonitoreoCultivoPlagasRequestSchema: GenMessage<ListMonitoreoCultivoPlagasRequest> = /*@__PURE__*/
  messageDesc(file_catalogos_monitoreo, 5);

/**
 * Filas que cambiaron desde la ultima sincronizacion.
 *
 * @generated from message sextante.catalogos.monitoreo.v1.ListMonitoreoCultivoPlagasResponse
 */
export type ListMonitoreoCultivoPlagasResponse = Message<"sextante.catalogos.monitoreo.v1.ListMonitoreoCultivoPlagasResponse"> & {
  /**
   * @generated from field: repeated sextante.catalogos.monitoreo.v1.MonitoreoCultivoPlagaItem items = 1;
   */
  items: MonitoreoCultivoPlagaItem[];

  /**
   * @generated from field: int64 timestamp_sincronizacion = 2;
   */
  timestampSincronizacion: bigint;
};

/**
 * Describes the message sextante.catalogos.monitoreo.v1.ListMonitoreoCultivoPlagasResponse.
 * Use `create(ListMonitoreoCultivoPlagasResponseSchema)` to create a new message.
 */
export const ListMonitoreoCultivoPlagasResponseSchema: GenMessage<ListMonitoreoCultivoPlagasResponse> = /*@__PURE__*/
  messageDesc(file_catalogos_monitoreo, 6);

/**
 * Pedido del catalogo de plagas y enfermedades.
 *
 * @generated from message sextante.catalogos.monitoreo.v1.ListMonitoreoPlagaEnfermedadesRequest
 */
export type ListMonitoreoPlagaEnfermedadesRequest = Message<"sextante.catalogos.monitoreo.v1.ListMonitoreoPlagaEnfermedadesRequest"> & {
  /**
   * Delta: ultima sincronizacion en Unix ms, el timestamp_sincronizacion de la respuesta anterior. Con 0 trae
   * todo.
   *
   * @generated from field: int64 ultima_sincronizacion = 1;
   */
  ultimaSincronizacion: bigint;
};

/**
 * Describes the message sextante.catalogos.monitoreo.v1.ListMonitoreoPlagaEnfermedadesRequest.
 * Use `create(ListMonitoreoPlagaEnfermedadesRequestSchema)` to create a new message.
 */
export const ListMonitoreoPlagaEnfermedadesRequestSchema: GenMessage<ListMonitoreoPlagaEnfermedadesRequest> = /*@__PURE__*/
  messageDesc(file_catalogos_monitoreo, 7);

/**
 * Plagas y enfermedades que cambiaron desde la ultima sincronizacion.
 *
 * @generated from message sextante.catalogos.monitoreo.v1.ListMonitoreoPlagaEnfermedadesResponse
 */
export type ListMonitoreoPlagaEnfermedadesResponse = Message<"sextante.catalogos.monitoreo.v1.ListMonitoreoPlagaEnfermedadesResponse"> & {
  /**
   * @generated from field: repeated sextante.catalogos.monitoreo.v1.MonitoreoPlagaEnfermedadItem items = 1;
   */
  items: MonitoreoPlagaEnfermedadItem[];

  /**
   * Hora del servidor en Unix ms, tomada antes de consultar. La app la guarda y la manda como
   * ultima_sincronizacion en el proximo pedido.
   *
   * @generated from field: int64 timestamp_sincronizacion = 2;
   */
  timestampSincronizacion: bigint;
};

/**
 * Describes the message sextante.catalogos.monitoreo.v1.ListMonitoreoPlagaEnfermedadesResponse.
 * Use `create(ListMonitoreoPlagaEnfermedadesResponseSchema)` to create a new message.
 */
export const ListMonitoreoPlagaEnfermedadesResponseSchema: GenMessage<ListMonitoreoPlagaEnfermedadesResponse> = /*@__PURE__*/
  messageDesc(file_catalogos_monitoreo, 8);

/**
 * Migracion a gRPC-Web del catalogo de plagas/enfermedades (ver CLAUDE.md, seccion migracion a
 * gRPC-Web y "Cultivos generales nuevos y plagas de Papa"). Mismo criterio de delta que
 * catalogos_aplicaciones.proto (incluido no exponer "ultima_actualizacion" -ver ese archivo-).
 *
 * @generated from service sextante.catalogos.monitoreo.v1.CatalogosMonitoreoService
 */
export const CatalogosMonitoreoService: GenService<{
  /**
   * Catalogo de plagas y enfermedades, por delta.
   *
   * @generated from rpc sextante.catalogos.monitoreo.v1.CatalogosMonitoreoService.ListMonitoreoPlagaEnfermedades
   */
  listMonitoreoPlagaEnfermedades: {
    methodKind: "unary";
    input: typeof ListMonitoreoPlagaEnfermedadesRequestSchema;
    output: typeof ListMonitoreoPlagaEnfermedadesResponseSchema;
  },
  /**
   * Valores de referencia por cultivo (la "tabla B" de la especificacion v1.0, 3.2 B). Con delta.
   *
   * @generated from rpc sextante.catalogos.monitoreo.v1.CatalogosMonitoreoService.ListMonitoreoCultivoPlagas
   */
  listMonitoreoCultivoPlagas: {
    methodKind: "unary";
    input: typeof ListMonitoreoCultivoPlagasRequestSchema;
    output: typeof ListMonitoreoCultivoPlagasResponseSchema;
  },
  /**
   * Tamanos de fruta que el monitor registra por arbol. Con delta.
   *
   * @generated from rpc sextante.catalogos.monitoreo.v1.CatalogosMonitoreoService.ListMonitoreoTamanosFruta
   */
  listMonitoreoTamanosFruta: {
    methodKind: "unary";
    input: typeof ListMonitoreoTamanosFrutaRequestSchema;
    output: typeof ListMonitoreoTamanosFrutaResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_catalogos_monitoreo, 0);

